import { TableCell, TableCellProps } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import DisplayFormatedNumber from '../../../components/DisplayFormatedNumber'
import { HeaderCellVariant } from '../types/HeaderCellVariant'
import HeaderEnding from './HeaderEnding'

type VariantMapping = Record<HeaderCellVariant, string>

export interface SumCellProps extends Omit<TableCellProps, 'variant'> {
  sum?: number
  variant: HeaderCellVariant
  isLast?: boolean
  onClick?: TableCellProps['onClick']
  isActive?: boolean
}

const getStyleByVariantProp = (mapping: VariantMapping) => (props: SumCellProps) => mapping[props.variant]

const useStyles = makeStyles<Theme, SumCellProps>((theme) =>
  createStyles({
    headerCell: {
      position: 'relative',
      borderBottom: 'none',
      padding: 0,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      whiteSpace: 'nowrap' as any,
      height: getStyleByVariantProp({
        salary: '72px',
        revenue: 'auto',
      }),
      width: getStyleByVariantProp({
        salary: 'auto',
        revenue: '104px',
      }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(theme.typography.lato.main as any),
      textAlign: 'center',
      color: (props: SumCellProps) => {
        return getStyleByVariantProp({
          salary: '#003D75',
          revenue: '#00624F',
        })(props)
      },
      backgroundColor: getStyleByVariantProp({
        salary: '#E3EFF5',
        revenue: '#EDF8F7',
      }),
    },
    labelElement: {
      borderRadius: '4px',
      padding: '4px 8px',
      width: 'fit-content',
      minWidth: '65px',
      margin: '0 auto',
      backgroundColor: (props: SumCellProps) => {
        const bgColor = getStyleByVariantProp({
          salary: '#E3EFF5',
          revenue: '#A8DDD6',
        })(props)

        return props.isActive ? bgColor : 'unset'
      },
      '&:hover': {
        backgroundColor: (props: SumCellProps) => {
          const bgColor = getStyleByVariantProp({
            salary: '#E3EFF5',
            revenue: '#A8DDD6',
          })(props)

          return bgColor
        },
        cursor: 'pointer',
      },
    },
  })
)
const SumCell = ({ sum, variant, isLast, children, onClick, isActive, ...other }: SumCellProps) => {
  const classes = useStyles({ variant, isLast, isActive })

  return (
    <TableCell className={classes.headerCell} {...other} onClick={onClick}>
      {sum !== undefined ? (
        <div className={classes.labelElement}>
          <DisplayFormatedNumber value={sum} format="euroInt" />
        </div>
      ) : null}

      {isLast && <HeaderEnding variant={variant} cellType="sum" />}
    </TableCell>
  )
}

export default SumCell
